import { m, useReducedMotion } from 'motion/react';

const EASE = [0.16, 1, 0.3, 1] as const;
/** Semicírculo superior: de (20,100) arcando por cima até (180,100). */
const ARC = 'M 20 100 A 80 80 0 0 1 180 100';

interface GaugeChartProps {
  /** percentual (0..100 usado para preencher; fora da faixa é clampado). */
  percent: number;
  /** cor do arco preenchido (faixa calculada pelo chamador). */
  color: string;
}

/**
 * Medidor semicircular: trilho cinza + arco preenchido conforme %. Preenche via
 * pathLength. viewBox 0 0 200 120. Robusto a NaN / negativos (clampa em 0).
 */
export function GaugeChart({ percent, color }: GaugeChartProps) {
  const reduce = useReducedMotion();
  const safe = Number.isFinite(percent) ? percent : 0;
  const frac = Math.min(1, Math.max(0, safe / 100));
  const shown = Math.round(safe);

  return (
    <svg
      viewBox="0 0 200 120"
      className="mx-auto w-full max-w-[240px]"
      role="img"
      aria-label={`Taxa de economia: ${shown}%`}
    >
      <path d={ARC} fill="none" stroke="var(--color-border)" strokeWidth={16} strokeLinecap="round" />
      <m.path
        d={ARC}
        fill="none"
        stroke={color}
        strokeWidth={16}
        strokeLinecap="round"
        initial={reduce ? false : { pathLength: 0 }}
        animate={{ pathLength: frac }}
        transition={{ duration: reduce ? 0 : 0.8, ease: EASE }}
      />
      <text x={100} y={86} textAnchor="middle" className="fill-ink" fontSize={30} fontWeight={700}>
        {shown}%
      </text>
      <text x={100} y={106} textAnchor="middle" className="fill-muted" fontSize={11}>
        economia
      </text>
    </svg>
  );
}
